/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { BorderBottomRadius, BorderRadius, BorderTopRadius, BorderRightRadius, BorderLeftRadius } from './bootstrap/scss/mixins/_border-radius.mixin';
import { colorWithAlpha } from './bootstrap/scss/_functions';

export default $ => css`
  .preview-container {
    max-height: 350px;
    overflow-y: auto;
    background-color: #f8f9fa;
    border-radius: 5px;
  }

  .preview-content {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
  }

  .export-uwe-objects{
    .card-header{
        color: ${$.primaryMain} !important;
      }
  }

  form.rjsf {
    margin-top: 0px !important;
  }

  div.collapsable-tree-select {
      appearance: none !important;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23003887' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E") !important;
      background-repeat: no-repeat;
      background-position: right 12px center;
  }

  .form-tabs{
    margin-top: 0px !important;
  }

  .btn {
    transition: background-color 0.3s ease, transform 0.2s ease !important;
    will-change: transform !important;
    font-family: ${$.fontFamily};
  }

  .btn:not('.dropdown-item .btn'):hover {
    background: ${$.primaryMain} !important;
    transform: scale(1.03) !important;
    border-color: ${$.secondaryMain} !important;
  }

  .sidebar-hamburger {
    width: 50px;
  }

  @keyframes fadeSlideIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    .animated-show {
      animation: fadeSlideIn 0.3s ease-out;
    }

    @keyframes slideDown {
    0% {
      max-height: 0;
    }
    100% {
      max-height: 500px;
    }
  }

  .vertical-animated-show {
    animation: slideDown 0.3s ease-out;
    overflow: visible;
  }

  .vertical-animated-slow-show {
    animation: slideDown 0.6s ease-out;
    overflow: hidden;
  }

  .modern-loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    animation: fadeIn 0.3s ease;
  }

  .modern-loader.sm .spinner {
    width: 24px;
    height: 24px;
  }

  .spinner {
    animation: rotate 1s linear infinite;
    width: 48px;
    height: 48px;
  }

  .spinner .path {
    stroke: ${$.primaryMain};
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  .loader-text {
    font-size: 14px;
    color: #64748b;
    margin-top: 4px;
  }

  .loader-backdrop {
    position: fixed;
    inset: 0;
    background-color: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(4px);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loader-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }

  .table.animated-show, table.animated-show {
    animation: fadeInTable 0.3s ease-out forwards;
  }

  @keyframes fadeInCard {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeInTable {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeInTableRow {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  nav[aria-label='pagination'] {
    display: flex;
    justify-content: flex-end; /* Alinea el contenido del nav a la derecha */
    align-items: center;
    padding: 16px;
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }

  nav[aria-label='pagination'] {
    padding: 16px;
    background-color: #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 4px;
    width: 100%;
  }

  .page-item {
    display: inline-flex;
    align-items: center;
  }

  .page-link {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    height: 40px;
    padding: 0 12px;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #212121;
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    text-decoration: none;
    transition: all 0.3s ease;
    outline: none;
    cursor: pointer;
  }

  .page-link:focus {
    // box-shadow: 0 0 0 0.2rem rgba(0, 48, 135, 0.25);
  }

  .page-item.disabled .page-link {
    color: #9e9e9e;
    background-color: #f5f5f5;
    border-color: #e0e0e0;
    cursor: not-allowed;
    pointer-events: none;
  }

  .page-item.disabled .page-link:hover {
    background-color: #f5f5f5;
    border-color: #e0e0e0;
  }

  select.form-control {
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    padding: 8px 12px;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #212121;
    width:100%;
    background-color: #ffffff;
    box-shadow: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    height: 40px;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23003887' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    cursor: pointer;
  }

  select.form-control:focus {
    border-color: ${$.primaryMain}; /* Color de foco */
    // box-shadow: 0 0 0 0.2rem rgba(0, 48, 135, 0.25); /* Anillo de foco */
    outline: none;
  }

  select.form-control:hover {
    border-color: #bdbdbd; /* Borde más oscuro al hover */
    background-color: #f5f5f5; /* Fondo claro */
  }

  @media (max-width: 576px) {
    .pagination {
      flex-wrap: wrap;
      gap: 2px;
    }

    .page-link {
      min-width: 32px;
      height: 32px;
      padding: 0 8px;
      font-size: 12px;
    }

    select.form-control {
      width: 4em;
      height: 32px;
      padding: 6px 10px;
    }
  }

  .card {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    transition: box-shadow 0.3s ease !important;

    &.square {
      border-radius: 0;
    }

    &.square-top {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    &.square-bottom {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    > .card-header {
      .title {
        font-size: 18px;
        font-weight: 500;
        padding: 5px;
        padding-left: 0px !important;

        &.has-buttons {
          display: inline-block;
          vertical-align: bottom;
          padding-right: 2rem;
        }
      }

      .pagination {
        margin-bottom: 0;
      }
    }

    > .card-footer {
      background-color: #ffffff !important;
      border-top: 1px solid #dee2e6;
      border-radius: 0 0 ${$.borderRadiusLg} ${$.borderRadiusLg};
      .pagination {
        margin-bottom: 0;
        width:100%;
      }
    }

    > table {
      > thead th {
        font-weight: normal;
      }
    }

    &.primary {
      background-color: ${$.gray100};
      color: ${$.black};
      > table {
        background-color: ${$.white};
        > thead * {
          color: ${$.primaryMain};
        }
        > tbody {
          > tr {
            margin-top: 5px;
            background-color: ${$.white};
          }
        }
      }
      > .card-header {
        color: ${$.white};
        background-color: ${$.primaryMain};
      }
    }
  }

  .card.inbox-card {
    margin-bottom: ${$.mainContainerGap};
  }

  .no-bottom-gap {
    margin-bottom: 0 !important;
  }

  input.form-control,
  textarea.form-control,
  button.dropdown-toggle {
    border-radius: 4px;
    border: 1px solid ${$.inputBorderColor};
    padding: 8px 12px;
    font-size: 14px;
    font-family: 'Roboto', sans-serif;
    box-shadow: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    outline: none;
    width: 100%;
    height: auto;
    line-height: 1.5;
    box-sizing: border-box;
    margin: 0;
    position: relative;
  }


  input.form-control,
  textarea.form-control {
    background-color: #fff;
  }

  input.form-control[type='date'],
  textarea.form-control,
  button.dropdown-toggle,
  .autocomplete__control,
  .form-group:has(> input.form-control:only-child),
  .form-group:has(> text-area.form-control:only-child),
  .form-group:has(> .control-label + input.form-control[type='text']),
  .form-group:has(> .control-label + input.form-control[type='email']) {
    position: relative;
    height: fit-content;
  }

  input.form-control[type='date']::after,
  button.dropdown-toggle:not(.simple-dropdown-toggle)::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: ${$.primaryMain};
    transition: width 0.3s ease;
    z-index: 2;
  }

  input.form-control[type='date']:hover::after,
  button.dropdown-toggle:not(.simple-dropdown-toggle):hover::after {
    width: 100%;
  }

  .input-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
  }

  .input-wrapper::after,
  .autocomplete__control::after,
  .form-group:has(> input.form-control:only-child)::after,
  .form-group:has(> textarea.form-control:only-child)::after,
  .form-group:has(> .control-label + input.form-control[type='text'])::after,
  .form-group:has(> .control-label + input.form-control[type='email'])::after {
    content: '';
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 0;
    height: 1px;
    background-color: ${$.primaryMain};
    transition: width 0.3s ease;
    z-index: 2;
    margin-left: 3px;
    margin-right: 3px;
  }

  .form-group:has(> input.form-control:only-child)::after,
  .form-group:has(> textarea.form-control:only-child)::after,
  .form-group:has(> .control-label + input.form-control[type='text'])::after,
  .form-group:has(> .control-label + input.form-control[type='email'])::after {
    bottom: 1px;
  }

  .input-wrapper:has(select)::after {
    bottom: 1px;
  }

  .input-wrapper:hover::after,
  .form-group:has(> input.form-control:only-child):hover::after,
  .form-group:has(> textarea.form-control:only-child):hover::after,
  .form-group:has(> .control-label + input.form-control[type='text']):hover::after,
  .form-group:has(> .control-label + input.form-control[type='email']):hover::after,
  .autocomplete__control:hover::after {
    width: calc(100% - 6px);
  }

  input.form-control:focus,
  textarea.form-control:focus,
  button.dropdown-toggle:focus,
  .input-wrapper:focus-within .form-control {
    border-color: ${$.primaryMain};
    // box-shadow: 0 0 0 0.2rem rgba(0, 48, 135, 0.25);
    outline: none;
  }

  input.form-control:focus::after,
  textarea.form-control:focus::after,
  button.dropdown-toggle:not(.simple-dropdown-toggle):focus::after,
  .input-wrapper:focus-within::after,
  .autocomplete__control:focus::after {
    width: 0;
  }

  input.form-control[readonly],
  textarea.form-control[readonly] {
    background-color: #f5f5f5;
    opacity: 0.7;
    color: #616161;
    border-color: ${$.inputBorderColor};
    cursor: not-allowed;
  }

  input.form-control[readonly]:hover::after,
  textarea.form-control[readonly]:hover::after,
  .input-wrapper:hover::after[readonly] {
    width: 0;
  }

  .control-label {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    margin-bottom: 4px;
    color: #212121;
    font-size: 15px;
  }

  .form-group,
  .input-group {
    margin-bottom: 16px;
    position: relative;
    overflow: visible;
    padding: 0;
  }

  .table {
    font-size: 14px;
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 8px;
    overflow: hidden;
  }

  .table thead th {
    border-bottom: 0px !important;
    font-weight: 600;
    padding: 12px 16px;
    border-top: 0 !important;
  }

  .table td {
    border-bottom: 0px !important;
    padding: 12px 16px;
    vertical-align: middle;
  }

  .workTrayIcon {
    padding-bottom: 20px;
    text-align: center;

    img {
      cursor: pointer;
      max-width: 143px;
      transition: transform 0.3s ease;
    }

    img:hover {
      transform: scale(1.05);
    }

    .label {
      p {
        font-size: 19px !important;
        margin: 0px;
        font-weight: 500;
        font-family: 'Roboto', sans-serif;
      }
    }
  }

  .td-actionButtons {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 0;
  }

  .worktray {
    > .card:not(.form-errors) {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      border-radius: 0px !important;

      .card-header {
        border-radius: 10px 10px 0px 0px;
        padding: 10px 15px;
      }

      .btn:not(.dropdown-toggle):not(.filter-button):not(.btn-clear) {
        margin: 5px !important;
        padding: 4px 8px !important; 
        border-radius: 4px;
        text-transform: uppercase;
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        transition: background-color 0.3s ease;
      }

      .btn.filter-button{
        color: white !important;
        background: transparent !important;
        border: none;
        transition: transform 150ms ease-in-out;
      }
      .btn.filter-button:hover, .btn.filter-button.active{
        transform: scale(1.2);
      }

      .worktray-table-container > .table,
      > table {
        margin-bottom: 0;

        > * > tr {
          > th {
            height: 38px;
            padding: 8px 11px;
            font-weight: 500;
            border-bottom: 1px solid #e0e0e0; /* Subtle border */
          }

          > td {
            padding: 6px 11px;
            border-bottom: 1px solid #e0e0e0;

            div.alert {
            margin-bottom: 0px !important;
            }
          }

          > th > .btn,
          > td > .btn {
            white-space: nowrap;
            text-overflow: clip;
            padding: 3px 6px !important;
          }
        }
      }
    }
  }
  
  .mui-sidebar {
    width: 280px;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    transition: width 0.3s ease;
    overflow: hidden;
    flex-shrink: 0;
    border-right: 1px solid #bec8d0;
  }

  .mui-sidebar.mui-collapsed {
    width: 75px;
  }

  @media only screen and (max-width: 850px) {
    *, html body {
        font-size: 13px !important;
    }
  
    .mobile-table{
      background: #ffffff;
      height: 100%;
      overflow: auto;

      > .card {
        border-radius: 0 !important;
      }

      .loader-container {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    
    .worktray-filters-collapse {
      position: absolute;
      z-index: 1;
      width: 100%;
      top: 51px;
    }


    .show-when-mobile {
      display: block !important;
    }

    .mui-sidebar.mui-collapsed {
      width: 0px;
    }
  }

  .card:not(.form-errors) {
      display: flex;
      flex-direction: column;
      min-width: 0;
      height: ${$.cardHeight};
      word-wrap: break-word;
      background-color: ${$.cardBg};
      background-clip: border-box;
      // border: ${$.cardBorderWidth} solid ${$.cardBorderColor};
  
      > hr {
        margin-right: 0;
        margin-left: 0;
      }
  
      > .list-group {
        border-top: inherit;
        border-bottom: inherit;
  
        &:first-of-type {
          border-top-width: 0;
          ${new BorderTopRadius($.cardInnerBorderRadius).include($)};
        }
  
        &:last-child {
          border-bottom-width: 0;
          ${new BorderBottomRadius($.cardInnerBorderRadius).include($)};
        }
      }
  
      > .card-header + .list-group,
      > .list-group + .card-footer {
        border-top: 0;
      }
    }

    .worktray >.card{
        border-radius: 0px !important;
        background: transparent !important;
        border: 0 !important;
    }

    table{
    background:#ffffff;
    }

  .form-control:disabled, .form-control[readonly] {
      background-color: #f5f5f5;
      opacity: 0.7;
      color: #616161;
      border-color: #ced4da;
      cursor: not-allowed;
  }

  select.form-control:disabled,
  select.form-control[readonly] {
    background-image: none;
  }

  .control-label {
      font-weight: 500;
      font-size: 15px;
  }

  .mui-sidebar.mui-collapsed > .mui-sidebar-menu > .pc-item.pc-caption {
    visibility: hidden;
  }
  
  .mui-sidebar.mui-collapsed .mui-sidebar-text {
    width: 0px;
  }
  
  .mui-sidebar.mui-collapsed .nav-clock {
    display: none;
  }

  .mui-sidebar-header {
    padding: 16px;
    padding-bottom: 3px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0px;
  }

  .mui-sidebar-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mui-sidebar.mui-collapsed .mui-sidebar-header {
    padding-right: 0px;
  }
  
  .mui-sidebar-header h2 {
    font-size: 20px;
    font-weight: 500;
    color: #1976d2;
    margin: 0;
    display: flex;
    align-items: center;
  }

  .mui-sidebar-header .navbar-brand.nav-logo-icon {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  width: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
  text-decoration: none !important;
}

.mui-sidebar-header .navbar-brand.nav-logo-icon > * {
  flex-shrink: 0 !important;
}

.mui-sidebar-header .navbar-brand.nav-logo-icon svg,
.mui-sidebar-header .navbar-brand.nav-logo-icon img {
  min-width: 40px !important;
  width: auto !important;
  height: 40px !important;
}

  .mui-sidebar.mui-collapsed .mui-sidebar-header h2 span {
    display: none;
  }

  .mui-toggle-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: #757575;
    padding: 8px;
    border-radius: 6px;
    transition: background-color 0.2s;

    .fa {
      font-size: 18px !important;
    }
  }

  .mui-toggle-btn:hover {
    background-color: #e0e0e0;
  }

  .mui-sidebar-menu {
    flex-grow: 1;
    list-style: none;
    padding: 8px 0;
        overflow-x: auto;
  }

  .mui-menu-item {
    position: relative;
    display: flex;
    align-items: center;
    margin: 4px 16px;
    padding: 10px;
    color: #424242;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    border-radius: 5px;
    overflow: hidden;
    z-index: 1;
  }

  a:hover.mui-menu-item {
    text-decoration: none !important;
  }

  .mui-menu-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: ${$.primaryMain};
    opacity: 0.1;
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.3s ease;
    z-index: 0;
    border-radius: 5px;
  }

  .mui-menu-item:hover::before {
    transform: scaleX(1);
  }

  .mui-menu-item > * {
    position: relative;
    z-index: 1;
  }

  .mui-menu-item.active {
    color: white;

    .mui-text {
      color: white;
    }
  }

  .mui-menu-item.active::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: ${$.primaryMain};
    opacity: 1;
    border-radius: 5px;
    z-index: 0;
    transform: scaleX(1);
    transform-origin: center;
  }

  .mui-menu-item span.mui-icon {
    font-size: 20px;
    margin-right: 12px;
    width: 24px;
    text-align: center;
  }

  .mui-sidebar.mui-collapsed .mui-menu-item .mui-icon {
    margin: 0;
  }

  .mui-sidebar.mui-collapsed .mui-menu-item span.mui-text {
    display: none;
  }

  .mui-main-content {
    flex-grow: 1;
    flex-shrink: 1;
    overflow: auto;
    background: white;
    .navbar {
      background: white;
    }
  }

  @media (max-width: 768px) {
    .mui-sidebar-header h2 span {
      display: none;
    }

    .mui-sidebar div.user-name {
      font-size: 10px !important;
    }

    .mui-sidebar-menu {
      .nav-item{
        width: 100% !important;
      }
    }

    .pc-user-card {
      small {
        font-size: 13px !important;
      }
    }
    
    .mui-menu-item span.mui-text {
       font-size: 13px !important;
    }

    }

    body {
      display: flex !important;
      min-height: 100vh !important;
    }

    .app-layout {
      display: flex !important;
    }

    nav.navbar {
      color: ${$.primaryMain};
      height: 4rem;
      border-bottom: none;
      box-shadow: none;
      padding: 0;
      top: 0;
      right: 0;
      position: fixed;
      background: #f5f5f5;
      z-index: 1000;
      padding-left:20px;
      padding-right:20px;
  }

  .nav-logo-icon {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .clock{
    color: ${$.primaryMain};
    font-size: 24px;
  }

  .mui-text{
      font-size: 14px;
      font-weight: 400;
      color: #5b6b79;
  }

  .pc-item {
      margin: 0 10px;
      label {
      display: inline-block;
      margin-bottom: 0rem;
  }

}

  .pc-caption:first-of-type {
      padding-top: 10px !important;
  }

  .pc-caption {
      display: block;
      padding: 24px 23px 8px !important;
      padding-bottom: 0 !important;
      color: #3e4853;
      text-transform: uppercase;
      position: relative;
      line-height: 1.66;
      font-size: 11px;
      font-weight: 600;
  }

  .mui-sidebar .card {
    margin: 15px;
    border-radius: 5px 5px 5px 5px !important;
  }

  .mui-sidebar .card.pc-user-card {
    margin: 5px 15px 0px;
    box-shadow: none;
    background: #e7e7e7cc;
  }
  .mui-sidebar .card.pc-user-card .card-body {
    padding: 15px;
  }
  .mui-sidebar .card.pc-user-card .pc-user-links a {
    display: flex;
    align-items: center;
    padding: 8px 0px;
  }
  .mui-sidebar .card.pc-user-card .pc-user-links a i {
    font-size: 18px;
    margin-right: 10px;
  }
  .mui-sidebar .card.pc-user-card .mui-toggle-btn .fa {
    transition: transform 250ms ease-in-out;
  }
  .mui-sidebar .card.pc-user-card .mui-toggle-btn .fa.flipped {
    transform: rotate(180deg);
  }

  .mui-sidebar div.user-name {
    font-family: ${$.fontFamily};
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
  }

  .table{
    border-radius: 0px !important;
  }

  .user-nav-dropdown .dropdown-menu {
    top: 100% !important;
    left: auto !important;
    right: 0 !important;
    transform: none !important;
  }

  .card.pc-user-card .pc-user-links button {
    display: flex;
    align-items: center;
    color: #5b6b79;
    padding: 8px 0px;
    all: unset;
    margin: 5px;
    font-size:13px;
    cursor:pointer;
  }

  .card.pc-user-card .pc-user-links button:hover {
    color: ${$.primaryMain};
  }

  .card.pc-user-card .pc-user-links button i {
    font-size: 18px;
    margin-right: 10px;
  }
  .card.pc-user-card .pc-user-links a:focus, .card.pc-user-card .pc-user-links a:hover {
    color: #5b6b79;
  }

  .pc-user-item{
    padding: 10px;
    padding-top: 0px;
    padding-bottom: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #5b6b79;
  }

  .pc-user-item-option {
    width: 100% !important;
    display: block !important;
  }

  .pc-user-item-suboption {
    width: 100% !important;
    display: block !important;
    padding-left: 18% !important;
  }

  .pc-user-item-suboption:disabled,
  .pc-user-item-suboption[disabled] {
    width: 100% !important;
    display: block !important;
    padding-left: 18% !important;
    color: #000000 !important;
    cursor: default !important;
  }
    
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 10px;
    border: 2px solid transparent;
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }

  * {
    scrollbar-width: thin;          /* thin | auto | none */
    scrollbar-color: #888 transparent;
  }

  .collapsable-tree-select button:not(.dropdown-item button){
    margin: 0px !important;
    background: transparent !important;
    min-height: 39px;
    color: #000000 !important;
    white-space: nowrap;
  }

  .form-settings{
    .collapsable-tree-select button:not(.dropdown-item button){
      white-space: break-spaces;
    }
  }

  .collapsable-tree-select .btn{
      margin: 0px !important;
  }

  .collapsable-tree-select button:not('.dropdown-item .btn'):hover{
      margin: 0px !important;
      background: transparent !important;
      min-height: 39px;
      color: #000000 !important;
      white-space: nowrap;
      border: 1px solid #ced4da;
  }

  .collapsable-tree-select button::after{
    all:unset;
  }

  .dropdown > .dropdown-menu {
    min-width: 100%;
  }

  .medium-panel {
    width: 450px;
    max-height: 550px;
    overflow-y: auto;
    box-shadow: 0 4px 24px 0 rgba(62, 57, 107, 0.18);
    border: none;
    padding: 8px;
      position: absolute;
    inset: 0px 0px auto auto;
    margin: 0px;
    border-radius: 4px;
    padding: 26px;

  .dropdown-item {
      display: block;
      margin-left: 0px;
      margin-right: 0px;
      border-radius: 4px;
      padding: 16px;
      font-size: 14px;
      cursor: pointer;
  }

  .dropdown-item:not(:first-of-type) {
    margin-top: 10px;
  }

  .badged-icon {
    position: relative;
    padding-top: 20px;
  }

  .badged-icon .notification-date {
      position: absolute;
      top: 13px;
      right: 10px;
      font-size: 12px;
      color: #666;
  }

  p {    
    margin-top: 20px;
  }

  div.title {
    font-weight: 600;
    padding-left: 5px;
    margin-top: 5px !important;
    }

  }

  button.dropdown-toggle{
    margin: 0px !important;
    min-height: 39px;
    white-space: nowrap;
  }

  button.dropdown-toggle .btn{
      margin: 0px !important;
  }

  button.dropdown-toggle:hover{
    margin: 0px !important;
    min-height: 39px;
    white-space: nowrap;
    transform: none !important;
    border-width: 1px;
    border-style: solid;
  }

  // button.dropdown-toggle::after{
  //   all:unset;
  // }

  // .dropdown-item .btn{
  //   all:unset;
  // }

  .field-array-of-object{
    table{
      overflow: visible;
    }
  }

  .full-width {
    grid-column: 1 / -1; /* ocupa desde la primera hasta la última columna */
  }

  .tab-content{
    height: 100%;

    > .tab-pane.active {
      height: 100%;
    }

    .card-body{
      background: #FFFFFF !important;
    }
  }

  .search-bar{
    border: none !important;
  }
  
  .search-bar.card {
    > .card-body {
      padding-bottom: 0;

      > .rjsf {
        margin: 0
      }
    }

    > .card-footer {
      border-top: none !important;
      padding-top: 0;
    }
  }

  .collapsable-tree-select >.dropdown-toggle >span {
    overflow: visible;
  }

  .modern-hover-icon {
    font-size: 2rem;
    transition: all 0.1s ease;
  }

  .modern-hover-icon:hover {
    color: ${$.secondaryMain};
    transform: scale(1.2) rotate(2deg);
  }

  .div-login{
    width: 100%;
    max-width: 500px; /* el tamaño ideal del contenedor del login */
    margin: 3.5rem auto 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    box-sizing: border-box;

    .alert {
      margin-bottom: 0;
    }

    form.rjsf .form-group:last-of-type {
      // margin-bottom: 16px !important;
    }

    .btn {
      margin: 0px !important;
      border-radius: 4px;
      text-transform: uppercase;
      font-weight: 500;
      font-size: 12px;
      color: #ffffff;
      width: 100% !important;
      transition: background-color 0.3s ease;
      border-color: #ffffff;
    }

    .btn-secondary {
      margin-top: 15px !important;
      border-radius: 4px;
      text-transform: uppercase;
      font-weight: 500;
      font-size: 12px;
      color: ${$.secondaryMain};
      background: transparent !important;
      width: 100% !important;
      border-color: #ffffff;
    }

    h5 {
      font-family: ${$.fontFamily};
    }

    input, .input-wrapper {
      max-width: 100% !important;
    }

    .card {
      border-radius: 10px !important;
      border-top-left-radius: 0px !important;
      border-top-right-radius: 0px !important;
      border-top: 0px !important;
    }

    div.form-component {
        width: 100%;
    }

    .header-login{
      border-top-right-radius: 10px !important;
      border-top-left-radius: 10px !important;
      background: ${$.white};
      box-shadow: 0 4px 12px ${colorWithAlpha($.black, 0.05)};
      width: 100%;
      border: 1px solid ${colorWithAlpha($.black, 0.125)};
      border-bottom: 0px;
      padding:10px;
      padding-top: 25px !important;
      text-align: center;
    }
    .body-login {
      text-align: center;
      background: ${$.white};
      padding-top: 40px;
      padding-bottom: 12px;
      margin-bottom: 12px;
      box-shadow: 0 4px 12px ${colorWithAlpha($.black, 0.05)};
      border: 1px solid ${colorWithAlpha($.black, 0.125)};
      border-top-width: 0;

      > .prompt {
        display: inline-block;
        margin-bottom: 12px;
      }

      > .btn-secondary {
        color: ${$.black};
        border-color: ${$.black};
      }
    }

    legend#root__title{
      color: ${$.primaryMain} !important;
      background: ${$.white};
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 14px !important;
      padding-top: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #e0e0e0;
    }

    .card-body{
        border-top--right-radius: 0px;
    }
}

  .mui-main-content{
    .navbar-nav .nav-link:not(.dropdownOrganizationSelected){
      padding-right: 0px !important;
      padding-left: 0px !important;
    }
  }

  .mui-user-dropdown .card {
    margin: 15px;
    border-radius: 5px 5px 5px 5px !important;
  }

  .mui-user-dropdown .card.pc-user-card {
    margin: 10px;
    box-shadow: none;
    background: #e7e7e7cc;
  }

  .mui-user-dropdown .card.pc-user-card .card-body {
    padding: 15px;
  }

  .mui-user-dropdown .card.pc-user-card .pc-user-links a {
    display: flex;
    align-items: center;
    padding: 8px 0px;
  }

  .mui-user-dropdown .card.pc-user-card .pc-user-links a i {
    font-size: 18px;
    margin-right: 10px;
  }

  .pc-user-item{
    padding: 10px;
  }
  
  .medium-panel-user {
    width: 300px;
    max-height: 550px;
    overflow-y: auto;
    box-shadow: 0 4px 24px 0 rgba(62, 57, 107, 0.18);
    border: none;
    position: absolute;
    inset: 0px 0px auto auto;
    margin: 0px;
    border-radius: 4px;
    padding: 0px;
  }

  .dropdown-item {
      display: block;
      margin-left: 0px;
      margin-right: 0px;
      border-radius: 4px;
      padding: 0.2rem 0 0.2rem 0.5rem;
      font-size: 14px;
      cursor: pointer;

      .collapse {
        transition-duration: 150ms;
      }
      
      > button {
        height: 20px;
        width: 15px;
        padding: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        .fa-caret-down {
          font-size: 15px;
          transition: transform 150ms ease-in-out, font-size 150ms ease-in-out;
          
          &:hover {
            font-size: 20px;
            color: ${$.primaryMain};
          }
        }

        .fa-caret-down.rotate-90-ctclockwise {
          transform: rotate(-90deg);
        }
      }
  }

  .dropdown-organization-selected {
    .dropdown-item {
      border: none !important;
    }
      .dropdown-divider {
        border-top: 1px solid #eeeeee;
        margin: 0px;
    }
  }

  @media (max-width: 576px) {
      select.form-control {
          width: 100%;
          height: 39px;
          padding: 6px 10px;
      }
  }

  @media (max-width: 768px) {
    .mui-sidebar.mui-collapsed {
      width: 0px;
    }

    .mui-sidebar {
      width: 280px;
      position: fixed;
      background: #f5f5f5;
      top: 0;
      left: 0;
      height: 100vh;
      z-index: 1050;
      box-shadow: 2px 0 5px rgba(0, 0, 0, 0.3); /* Para dar efecto de capa encima */
    }
  }

  tbody tr td:has(a.btn) {
    justify-content: normal !important;
  }

.uweentity-form.form-component >.uweentity-title {
    position: relative;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    font-size: 20px;
    font-weight: bold;
    padding: 10px 15px;
}

  .uweentity-form{
      form.rjsf legend[id^='root_'][id$='__title'], .form-component legend {
          position: relative;
          cursor: default;
          background-color: transparent;
          // color: ${$.primaryMain};
          font-size: 20px;
          border-radius: 0.125rem 0.125rem 0 0;
          margin-bottom: 8px;
      }
    }


  form.rjsf legend[id^='root_'][id$='__title'] >.expandable {
      color: ${$.primaryMain};
  }

  .uweentity-form{
    .card:not(.card-shadow) {
      box-shadow: none !important;
    }
  }

  .form-container >.sidepanel >.expandable-tab-side-panel-tab {
      font-size: 1rem;
      border-width: 0;
      border: 1px solid ${$.primaryMain};
      border-bottom: 0px;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
  }

  .form-container{
    margin-left: -15px;
    margin-right: -15px;
    margin-bottom: 10px !important;
  }

  .form-control.composite-input-field {
      min-height: 40px;
      border: 1px solid ${$.inputBorderColor} !important;
      // max-width: 20rem;
  }

  .form-container >.sidepanel >.expandable-tab-side-panel-panel {
      border-top-right-radius: 10px !important;
      border-top-left-radius: 10px !important;
  }

  .form-container >.sidepanel >.expandable-tab-side-panel-panel >.card-header {
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
  }

  .form-container >.sidepanel >.expandable-tab-side-panel-panel >.card-header {
    position: relative;
    font-size: 16px;
    font-weight: bold;
    padding: 10px;
  }
  
  .form-container >.sidepanel >.expandable-tab-side-panel-panel >.card-header >.btn-bar {
    position: absolute;
    right: 6px;
    top: 8px;
    padding: 0;
  }

  .uweentity-form-full-expanded-sidepanel .card-header {
      position: relative;
      color: white;
      background-color: ${$.primaryMain};
      font-size: 16px;
      padding: 10px;
      font-weight: bold;
      display: flex;
      justify-content: space-between;
      align-items: center;

      > .btn-bar > .btn {
        background: transparent;
        border: none;
        border-radius: 50%;
        color: white;

        &:hover {
          color: ${$.primaryMain};
          background-color: white;
        }
      }
  }

  form.rjsf .form-group.bordered {
      border: 1px solid #f5f5f5;
      border-radius: 10px;
      padding: 10px;
  }

  .checkbox-toggle-button-field >.checkbox {
      color: #fff;
  }

  div.dropdown{
    .dropdown-menu {
      border: 0px solid rgba(0,0,0,0.15);
    }
  }

  .titleComponents >.dropdown >.btn.dropdown-toggle {
    background: ${$.primaryMain} !important;
    color: #fff !important;
  }

  div.form-submit-buttons {
    button{
        text-transform: uppercase;
        border-radius: 4px;
        font-size: 13px;
    }
    button:hover{
    color: #fff;
    }
  }

  .form-submit-buttons>:not(:first-of-type) {
    margin-left: 10px;
  }

  form.rjsf legend[id^='root_'][id$='__title']{
      position: relative;
      // color: ${$.primaryMain};
      background: transparent;
      font-size: 1.5rem;
      font-weight: bold;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      font-size: 16px;
      font-weight: bold;
      border-bottom: 1px solid rgba(0, 0, 0, 0.125);
      padding: 10px 0px;
      border-bottom: 0px !important;
  }

  legend[id$="_ns"].type-section {
      position: relative;
      // color: ${$.primaryMain};
      background: transparent;
      // font-size: 1.5rem;
      // font-weight: bold;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      // font-size: 16px;
      font-weight: bold;
      // border-bottom: 1px solid rgba(0, 0, 0, 0.125);
      padding: 10px 0;
  }

  [id^="root_array"] {
    legend[id$="_ns"].type-section {
        border-bottom: 0px !important;
    }
  }

  .form-errors .card-header{
    background: ${$.primaryMain} !important;
    border-radius: 10px 10px 0 0;
  }

  .form-errors{
    border: none !important;
    background-color: transparent  !important;
    .form-error-list{
        border-left: 1px solid ${$.primaryMain};
      border-right: 1px solid ${$.primaryMain};
  }
  
  }

  .settings-landing-page {
    height: auto;
  }

  .animate-transform {
    transition: transform 200ms ease-in-out;
    transform-origin: center;
  }

  .rotate180 {
    transform: rotate(180deg);
  }
}

.array-item-add {
  white-space: nowrap;
  margin-left: 1em;
}

.array-item {
  margin-left: 1em;
  padding-bottom: 1em;
}

.min-width-250 {
  min-width: 250px;
}

.min-width-300 {
  min-width: 300px;
}

.min-width-400 {
  min-width: 400px;
}
`;
